module.exports = __webpack_public_path__ + "img/volume_up.76256637.svg";